import type * as pdfjsLib from 'pdfjs-dist';
import { Paper } from '@mui/material';
import { isNotNullOrUndefined } from '@weft/utils';
import React, { useEffect, useRef } from 'react';

const PDF_VIEWER_SCALE = 3;

type PdfViewerPageProps = {
  page: pdfjsLib.PDFPageProxy;
};

export const PdfViewerPage: React.FC<PdfViewerPageProps> = ({ page }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas?.getContext('2d');

    if (isNotNullOrUndefined(canvas) && isNotNullOrUndefined(context)) {
      const viewport = page.getViewport({ scale: PDF_VIEWER_SCALE });
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      canvas.style.height = '100%';
      canvas.style.width = '100%';

      const renderContext = {
        canvasContext: context,
        viewport,
      };
      page.render(renderContext);
    }
  }, [page]);

  return (
    <Paper
      elevation={3}
      sx={{
        display: 'flex',
        maxWidth: '90vh',
      }}
    >
      <canvas
        className="grow block min-w-[0px]"
        ref={canvasRef}
      />
    </Paper>
  );
};